import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { AuthenticationService } from '../../_services/authentication.service';
import { UserProfileService } from '../../_services/user-profile.service';
import { Error } from '../../_models/messages';
import { UserProfile } from '../../_models/user-profile';
import * as jwt_decode from 'jwt-decode';
import { ConfigurationService } from '../../_services/configuration.service';
import { takeUntil } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm: UntypedFormGroup;
  isLoading: boolean;
  isSubmitting: boolean;
  infoClass: string = "alert alert-warning";
  infoMessage: string = "";
  showCreateActBtn: boolean = false;
  requestedReportId: string = '';
  redirectToReport: boolean = false;
  error: Error = new Error;
  // Subjects
  private onDestroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private userProfileService: UserProfileService,
    private configurationService: ConfigurationService,
    private builder: UntypedFormBuilder,
    private titleService: Title
  ) {
    this.loginForm = this.builder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
    this.showCreateActBtn = this.configurationService.config.showCreateActBtn;
    this.configurationService.configData$.pipe(takeUntil(this.onDestroy$)).subscribe(
      configData => { this.showCreateActBtn = configData.showCreateActBtn }
    );
  }

  ngOnInit() {
    this.titleService.setTitle('Login - Productioneer Portal');
    this.isLoading = true;

    this.route.queryParams.subscribe((params: Params) => {
      if (params['expiredSession']) {
        this.infoClass = "alert alert-warning";
        this.infoMessage = "Your session has expired. Please login.";
      }
      if (params['logoutSuccess']) {
        this.infoClass = "alert alert-success";
        this.infoMessage = "You have been logged out successfully.";
      }
      if (params['reportid']) {
        this.requestedReportId = params['reportid'];
        this.redirectToReport = true;
        this.infoClass = "alert alert-info"
        this.infoMessage = "To view the requested report, please login.";
      }
      if (params['dashboardid']) {
        this.infoClass = "alert alert-info"
        this.infoMessage = "To view the requested report, please login.";
      }
    })

    if (this.authenticationService.isAuthenticatedWithSelectedCompany()) {
      this.router.navigate(['app/home']);
    }
    else {
      if (this.authenticationService.isAuthenticated()) {
        this.router.navigate(['company-select'], { queryParams: { fromLogin: 'true' } });
      } else {
        this.isLoading = false;
      }
    }
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onLogin() {
    this.infoMessage = null;
    this.error.isPresent = false;
    this.isSubmitting = true;
    this.authenticationService.login(this.loginForm.value)
      .subscribe(
        data => {
          let token = data;
          let payload = jwt_decode(token);
          /* Store user information */
          let userProfile: UserProfile = new UserProfile;
          userProfile.token = token;
          userProfile.exp = payload.exp;
          userProfile.nbf = payload.nbf;
          userProfile.name = payload.name;
          userProfile.isSuperAdmin = payload.IsSuperAdmin.toLowerCase() === 'true' ? true : false;
          localStorage.setItem("userProfile", JSON.stringify(userProfile));
          localStorage.setItem("tokendecoded", JSON.stringify(payload));
          localStorage.setItem("token", JSON.stringify(token));
          this.userProfileService.updateProfile(userProfile);
          if (this.redirectToReport) {
            this.router.navigate(['company-select'], {
              queryParams: {
                fromLogin: 'true',
                reportid: this.requestedReportId
              }
            });
          }
          else {
            this.router.navigate(['company-select'], { queryParams: { fromLogin: 'true' } });
          }
        },
        err => {

          if (err.status == 403) {
            /* Redirect to password reset component if first time logging in for user */
            let resetToken = err.error;
            this.router.navigate(['/passwordreset'], { queryParams: { token: resetToken, first: 'true' } });
          }
          else {
            this.error.isPresent = true;
            this.error.message = err.error || "Bad credentials. Please check username and password and resubmit.";
          }
          
          this.isSubmitting = false;
        }
      )
  }
}
